import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { UserSettingsDto } from '../types/index';
import { UserKeys } from './user.keys';

export const updateUserOmitFromReporting = (
  id: string | undefined,
  omitFromReportingSetting: boolean,
) => {
  if (id === null || undefined) {
    throw new Error('id is required');
  }

  const userSettingsDto: UserSettingsDto = {
    omitFromReporting: omitFromReportingSetting,
  };

  return clients.admin.post(`/users/omitfromreporting/${id}`, userSettingsDto).then(() => {});
};

export function useUpdateUserOmitFromReporting(
  id: string | undefined,
  options?: UseMutationOptions<void, AxiosError, boolean>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    (omitFromReportingSetting: boolean) =>
      updateUserOmitFromReporting(id, omitFromReportingSetting),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(UserKeys.lists());
        queryClient.invalidateQueries(UserKeys.details());
      },
      onError: (error) => {
        console.error(error);
      },
      ...options,
    },
  );
}
